import { SideBarPreview, SideBarPreviewProps } from './SideBarPreview'
import { FC } from 'react'
import { SideBarActionButton } from './actions/SideBarActionButton'
import { Action } from './actions/types'

type SideBarActionsPreviewProps = SideBarPreviewProps & {
  mainAction?: Action | null
  children?: React.ReactNode
}

export const SideBarActionsPreview: FC<SideBarActionsPreviewProps> = ({
  cover,
  avatar,
  title,
  mainAction,
  children,
}) => {
  return (
    <div>
      <SideBarPreview cover={cover} avatar={avatar} title={title}>
        {children}
      </SideBarPreview>
      {mainAction && (
        <div className="px-m">
          <SideBarActionButton
            action={mainAction}
            className="flex-1"
            buttonClassName="w-full"
          />
        </div>
      )}
    </div>
  )
}
